// extracted by mini-css-extract-plugin
module.exports = {"container":"Comment_container__15dfH","replyActions":"Comment_replyActions__a2LsJ","mask":"Comment_mask__27aYs"};